module.exports = __webpack_public_path__ + "img/img11.f9e32f7b.png";